module.exports = __webpack_public_path__ + "4f57fd38bcfe137f85fa5e09a1d17465.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NonAuthHomePage/components/Banner/components/Background/images/unionWave.svg
// module id = rlhl
// module chunks = 13